/**
 * Configurazione limiti upload file
 * Modifica questi valori per cambiare i limiti senza toccare il codice
 */
export const UPLOAD_LIMITS = {
  // Limite massimo per singolo file in MB
  MAX_FILE_SIZE_MB: 6,
  
  // Limite massimo totale per richiesta in MB
  MAX_TOTAL_SIZE_MB: 25,
  
  // Risoluzione massima per compressione immagini
  MAX_IMAGE_RESOLUTION: 1920,
  
  // Qualità iniziale per compressione (0.1 - 1.0)
  COMPRESSION_QUALITY: 0.8
} as const;


/**
 * 
 * Valori suggeriti per compressione:
    Leggera: 1920px, 0.8 qualità
    Media: 1280px, 0.6 qualità ← attuale
    Aggressiva: 1024px, 0.5 qualità
 */
